<template>
  <div :flaseProp="getConfiguredCategoryApiFailData">
    <shimmer-categories v-if="apiCategoryDataLoading" :gridView="showGridView"/>
    <div
      v-else-if="(HorizontalBannerData?.length > 0 || apiConfiguredCategoryData?.length > 0) && shouldModuleVisible"
      class="horizontal-menu mb32 pr0 col-sm-12 pl0 carousel-pr-12"
      id="undefined-horizontal-banner-with-text"
      :counterTextObserver="productObserver"
    >
      <!-- without carousel -->
      <template v-if="isGridViewVariant">
        <h3 class="card-catg-name mb16">{{ title }}</h3>
        <ul class="grid-view" style="min-height:300px">
          <li v-for="(offer, index) in HorizontalBannerData" :key="index">
            <div
              class="flex-column flex-wrap cursor-pointer"
              :class="{
                disabled:
                  getBottomBarData[offer?.title]?.data &&
                  Object.keys(
                    getBottomBarData[
                      (offer?.title || '').trim().replace('\n', ' ')
                    ]?.data
                  )?.length == 0,
              }"
              @click="
                goto(
                  offer,
                  index,
                  (getBottomBarData[
                    (offer?.title || '').trim().replace('\n', ' ')
                  ]?.data &&
                    Object.keys(
                      getBottomBarData[
                        (offer?.title || '').trim().replace('\n', ' ')
                      ]?.data
                    )?.length) ||
                    -1
                )
              "
            >
              <div class="menu-img-wrap">
                <template v-if="offer?.categoryImages?.length > 0">
                  <lazy-image
                    class="horizontal-item flex-row img-category-menu"
                    alt="default image"
                    :src="
                      Utility.getProductImages(
                        offer?.categoryImages,
                        'CategoriesV1'
                      )
                    "
                    :src-placeholder="getPlaceHolderImg"
                    loading="lazy"
                    :intersection-options="{ threshold: '1' }"
                  />
                </template>
                <template v-else>
                  <lazy-image
                    class="horizontal-item flex-row img-category-menu-fallback"
                    alt="offer image"
                    :src="offer?.imageUrl + Utility.getSitePropsVersion()"
                    :src-placeholder="getPlaceHolderImg"
                    loading="lazy"
                    :intersection-options="{ threshold: '1' }"
                  />
                </template>
              </div>
              <span class="fs-11 color-slaty bold mt10 tc">{{
                offer?.title
              }}</span>
            </div>
          </li>
        </ul>
      </template>

      <!-- with carousel -->
      <template v-else >
        <h3 class="card-catg-name mb12">{{ title }}</h3>
        <Carousel
          :pauseAutoplayOnHover="true"
          :transition="500"
          :itemsToShow="itemsToShow"
          style="min-height:150px"
        >
          <Slide v-for="(offer, index) in HorizontalBannerData" :key="index">
            <div
              class="flex-column flex-wrap cursor-pointer"
              @touchstart.stop
              @touchmove.stop
              :class="{
                disabled:
                  getBottomBarData[(offer?.title || '').trim().replace('\n', ' ')]
                    ?.data &&
                  Object.keys(
                    getBottomBarData[
                      (offer?.title || '').trim().replace('\n', ' ')
                    ]?.data
                  )?.length == 0,
              }"
              @click="
                goto(
                  offer,
                  index,
                  (getBottomBarData[
                    (offer?.title || '').trim().replace('\n', ' ')
                  ]?.data &&
                    Object.keys(
                      getBottomBarData[
                        (offer?.title || '').trim().replace('\n', ' ')
                      ]?.data
                    )?.length) ||
                    -1
                )
              "
            >
              <div class="menu-img-wrap">
                <template v-if="offer?.categoryImages?.length > 0">
                  <lazy-image
                    class="horizontal-item flex-row img-category-menu"
                    alt="default image"
                    :src="
                      Utility.getProductImages(
                        offer?.categoryImages,
                        'CategoriesV1'
                      )
                    "
                    :src-placeholder="getPlaceHolderImg"
                    :intersection-options="{ threshold: '1' }"
                  />
                </template>
                <template v-else>
                  <lazy-image
                    class="horizontal-item flex-row img-category-menu-fallback"
                    alt="offer image"
                    :src="offer?.imageUrl + Utility.getSitePropsVersion()"
                    :src-placeholder="getPlaceHolderImg"
                    :intersection-options="{ threshold: '1' }"
                  />
                </template>
              </div>
              <span class="fs-11 color-slaty bold mt10">{{ offer?.title }}</span>
            </div>
          </Slide>
          <template #addons> </template>
        </Carousel>
      </template>

      <!-- with vieaw all category -->
      <template v-if="isViewAllCategoryVariant">
        <div class="plr12 tc fs-14 bold mt24">
          <div
            class="tag-bg-white pTB10 disp-col-inline justify-content-center"
            @click="triggerNewMenuModal()"
          >
            <span
              class="menu-anchor-full-menu fs-13 flex-row justify-content-center mr12"
            >
              <i aria-hidden="true" class="jfi-list-view"></i>
            </span>
            Full Menu
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup>
import LazyImage from "./LazyImage.vue";
</script>
<script>
import { Carousel, Slide } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";
import { staticImgBaseUrl } from "../config/apiEndpoints";
import Utility from "../helpers/utility";
import setEvents from "../helpers/events";
import { keyMapsMutation , keyMapsAction , keyMapsGetter} from "../helpers/storeKeys";
import {
  v2PwaBasePath,
  imgBaseUrl,
  projectBasePathWithFolder,
} from "../config/apiEndpoints";
import {
  VWO_NEXTGEN_HOMEPAGE_EXPERIMENT,
  VWO_NEXTGEN_EXPERIMENT_VARIANTS,
} from "../config/vwoKeys";
import UserActivityTracking from "../helpers/UserActivityTracking";
import localStorageFunc from "../helpers/localStorageFunc";
import PageNames from "../config/pageNames";
import ShimmerCategories from "./ShimmerCategories.vue";
import amplitude from "amplitude-js";

export default {
  name: "HorizontalBannerWithText",
  components: {
    Carousel,
    Slide,
    ShimmerCategories,
  },
  props: ["dataResults", "moduleProps" , "dataApi"],
  data() {
    return {
      HorizontalBannerData: [],
      modulePropsData: {},
      itemsToShow: 1,
      staticImgBaseUrl: staticImgBaseUrl,
      imgBaseUrl: imgBaseUrl,
      eleIdToObserve: "undefined-horizontal-banner-with-text",
      showGridView: false,
      title: 'What are you craving for?',
      eventFlag: true,
      gridTypeV2:'',
      flagForGridV2:false,
      afterExclusionItemCount: null,
    };
  },
  mounted() {
    this.HorizontalBannerData =
      typeof this.dataResults != null &&
      typeof this.dataResults != "null" &&
      typeof this.dataResults != "undefined"
        ? JSON.parse(this.dataResults)
        : [];

    if(this.HorizontalBannerData?.length === 1){
      const {data , meta} = this.HorizontalBannerData[0];
      this.HorizontalBannerData = data || this.HorizontalBannerData;
      this.gridTypeV2 = meta?.menuType || '';
      if(this.gridTypeV2 && data){
        this.flagForGridV2 = true;
      }
    }

    this.modulePropsData =
      typeof this.moduleProps != null &&
      typeof this.moduleProps != "null" &&
      typeof this.moduleProps != "undefined"
        ? JSON.parse(this.moduleProps)
        : {};

    if (
      this.modulePropsData?.afterExclusionItemCount &&
      Number(this.modulePropsData?.afterExclusionItemCount)
    ) {
      this.afterExclusionItemCount = Number(
        this.modulePropsData?.afterExclusionItemCount,
      );
      this.HorizontalBannerData = this.HorizontalBannerData.slice(
        0,
        this.afterExclusionItemCount,
      );
    }    

    this.showGridView = this.modulePropsData?.gridView === 'true';

    if(this.shouldModuleVisible ){
      if(this.dataApi){
        this.apiConfiguredCategory();
        if(this.modulePropsData.title != undefined && this.modulePropsData.title){
          this.title = this.modulePropsData.title;
        }
      }
      else{//old case
        const dataLength = this.HorizontalBannerData?.length || 0;
        let eventTypeVal = 'carousal';
        if(this.showGridView){
          if(dataLength > 6){
            eventTypeVal = '3*3';
          }
          else{
            eventTypeVal = '2*3';
          }
        }
        this.addUserPropEvent(this.flagForGridV2 , eventTypeVal);
        this.sendEvent(this.flagForGridV2);
      }
    } 
    this.itemsToShow = +this.modulePropsData?.itemsInScreen;
    if (
      this.productObserver &&
      this.eleIdToObserve &&
      document.getElementById(this.eleIdToObserve)
    ) {
      this.productObserver.observe(
        document.getElementById(this.eleIdToObserve)
      );
    }
  },
  destroyed() {
    if (this.observer) {
      this.observer.unobserve(document.getElementById(this.eleIdToObserve));
    }
    if (this.isViewAllCategoryVariant) {
      window.removeEventListener("scroll", this.watchProductCounterString);
    }
  },
  methods: {
    goto(item, index, count) {
      //Amplitude click event load
      UserActivityTracking.category(0, item.title);
      const preEventObj = {
        positionWithinSection: index + 1,
        category: item?.title?.toLowerCase(),
      };
      const eventObj = Utility.amplitudeEventObj(
        "click",
        "explore menu section",
        "5",
        preEventObj
      );
      setEvents("amplitude", "Click", eventObj);

      let exp = this.$store.state.Config.vwoExperiments;
      let variant = exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT];
      if (
        variant === VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_U ||
        variant === VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_W ||
        variant === VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_X ||
        variant === VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_Y ||
        (
          Utility.getLinkRewriteFromSiteprops() === PageNames.NEXTGEN_LINKREWRITE_HOME ||
          Utility.getLinkRewriteFromSiteprops() === PageNames.NEXTGEN_LINKREWRITE_HOME_GUEST
        )
      ) {
        this.scrollToCategoryId(item);
      } else {
        if (!count) return;

        this.$store.commit(keyMapsMutation.TRIGGER_FILTER_REF, {});
        let itmId = item?.links[0].href;
        if (itmId) {
          let scrollTopMargin = 70; //default
          if (this.isAnchorLinkVariant) {
            scrollTopMargin = window.screen.width <= 321 ? 70 : 102;
          }
          setTimeout(() => {
            Utility.scrollUptoTo("element_catg_" + itmId, scrollTopMargin);
            this.$store.commit(keyMapsMutation.OPEN_ALL_CARDS, true);
          }, 0);
        }
      }
    },
    eventFunction(isClicked = false, preEventObj = {}) {
      let eventType = isClicked ? "Click" : "Impression";
      let userAction = isClicked ? "click" : "impression";
      const eventObj = Utility.amplitudeEventObj(
        userAction,
        preEventObj["sectionName"] ? preEventObj["sectionName"] : "bottom menu",
        "-1",
        preEventObj
      );
      setEvents("amplitude", eventType, eventObj);
    },
    triggerNewMenuModal() {
      let menuArray = [];
      menuArray = Object.keys(this.getBottomBarData).map((item) =>
        item.toLowerCase()
      );

      //Amplitude click event load
      this.eventFunction(true, {
        positionWithinSection: "",
        sectionName: "full menu home",
        category: "full menu home",
      });

      document.body.classList.add("body-stop-scroll-mobile");
      this.$store.commit(keyMapsMutation.UPDATE_NEW_MENU_MODAL_FLAG, true);
      this.$store.commit(
        keyMapsMutation.UPDATE_MENU_MODAL_FLAG_OPENED_FROM,
        "all categories"
      );

      //Amplitude impression event load
      this.eventFunction(false, {
        sectionName: "full menu home",
        subSection: "full menu home",
        menuCategories: menuArray,
        menuCount: menuArray?.length,
      });
      UserActivityTracking.menuOpen(0);
    },
    scrollToCategoryId(item) {
      if (item) {
        const { links = []} = item;
        let action = links[0]?.action;

        let url =
          projectBasePathWithFolder +
          Utility.getMenuCategory() +
          localStorageFunc.storeId() +
          Utility.getUrlQueryString();
        if (
          action === "menu" ||
          action === "MENU_LIST" ||
          action === "PRODUCT_LIST"
        ) {
          url = Utility.addUpdateParam(url, "showSearchModal", false);
          url = Utility.addUpdateParam(url, "scrollTo", links[0].href);
          window.location.href = url;
        } else if(action === "edv"){
          const hrefIs = links[0]?.href;
          if(hrefIs == '7'){
            window.location.href = `${v2PwaBasePath}/${action}?type=199`;
          }
          else if(hrefIs == '6'){
            window.location.href = `${v2PwaBasePath}/${action}?type=99`;
          } else{
            window.location.href = `${v2PwaBasePath}/${action}`;
          }
        } else if (
          action === "edvitems" ||
          action === "edvList" ||
          action === "offers"
        ) {
          window.location.href = `${v2PwaBasePath}/${action}`;
        } else if (action === "gamifyWebview" || action === "redirect") {
          window.location.href = `${v2PwaBasePath}/${links[0]?.href}`;
        } else if (action === "reward") {
          window.location.href = `${v2PwaBasePath}/${window?._siteProps_?.props?.postorderUIBasepath}pizzaLoyalty`;
        }else {
          url = Utility.addUpdateParam(url, "showSearchModal", false);
          url = Utility.addUpdateParam(url, "scrollTo", "menuTop");
          window.location.href = url;
        }
        return;
      }
    },
    watchProductCounterString() {
      if (
        window.pageYOffset < 50 &&
        !this.productCounterString.startsWith("undefined")
      ) {
        this.$store.commit(
          keyMapsMutation.SET_PRODUCT_COUNTER_STRING,
          "undefined"
        );
      }
    },
    apiConfiguredCategory() {
      let dataApiConstruct = this.dataApi.split("?")[0];
      const env = window._siteProps_?.props?.build_env_var;
      let tenant = 'Dominos'
      if(env == 'stage3' || env == 'dev4'){
        tenant = 'DominosProd'
      }
      if (
        dataApiConstruct !== undefined &&
        dataApiConstruct !== null &&
        dataApiConstruct != false
      ) {
        this.$store.dispatch(keyMapsAction.GET_CONFIGURED_CATEGORY_DATA, {
          api: dataApiConstruct,
          tenant: tenant,
          menuType: this.shouldComponentVisibleAccFrequency
        });
      }
    },
    sendEvent(flag = false , error = false , errorMsg = null){
    //Amplitude impression event load
    if(error){
      const eventObj = Utility.amplitudeEventObj(
        'nghEMError',
        'explore menu section',
        '-1',
        {
          storeID: localStorageFunc.storeId(),
          loadTime: this.getApiLoadeTime,
          errorType: errorMsg
        }
      );
      setEvents("amplitude", 'nghEMError', eventObj);
    }
    else{
      const eventObj = Utility.amplitudeEventObj(
        flag ? 'nghEMImpression' : "impression",
        "explore menu section",
        "5",
        {
          category: this.HorizontalBannerData?.map((_) => {
            return _.title?.toLowerCase();
          }),
          storeID: localStorageFunc.storeId(),
          loadTime: this.getApiLoadeTime,
          categoryCount: this.HorizontalBannerData?.length,
          gridType: this.getMenuGridType?.toLowerCase(),
        }
      );
      setEvents("amplitude", flag ? 'nghEMImpression' : "Impression", eventObj);
    }
    },
    addUserPropEvent(visible = false , eventTypeVal){
      const moduleEventObjUserProp = {
        "nghEMVisible" : visible ? 'yes': 'no',
        "nghEMType" : visible ? eventTypeVal : 'not visible',
        "nghGridType" : visible ? this.getMenuGridType?.toLowerCase() : 'not visible',
      }
      amplitude.setUserProperties(moduleEventObjUserProp);
    },
  },
  computed: {
    getBottomBarData() {
      return this.$store.state.ProductItems.productItems;
    },
    isGridViewVariant() {
      let exp = this.$store.state.Config.vwoExperiments;
      let variant = exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT];
      if (
        variant === "nextgen_variant_e" ||
        variant === "nextgen_variant_u" ||
        variant === "nextgen_variant_w" ||
        variant === "nextgen_variant_x" ||
        variant === "nextgen_variant_y" ||
        this.showGridView
      ) {
        return true;
      } else {
        return false;
      }
    },
    isViewAllCategoryVariant() {
      let exp = this.$store.state.Config.vwoExperiments;
      if (
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ===
        VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_T
      ) {
        window.addEventListener("scroll", () => {
          this.watchProductCounterString();
        });
        return true;
      } else {
        return false;
      }
    },
    productObserver() {
      let observer = this.$store.state.ProductItems.productObserver;
      if (
        observer &&
        this.eleIdToObserve &&
        document.getElementById(this.eleIdToObserve)
      ) {
        observer.observe(document.getElementById(this.eleIdToObserve));
      }
      return observer;
    },
    isAnchorLinkVariant() {
      let exp = this.$store.state.Config.vwoExperiments;
      if (
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ===
          VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_S ||
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ===
          VWO_NEXTGEN_EXPERIMENT_VARIANTS.CONTROL
      ) {
        return true;
      } else {
        return false;
      }
    },
    productCounterString() {
      return this.$store.state.ProductItems.productCounterString;
    },
    apiCategoryDataLoading(){
      return this.$store.state.HorizontalBannerWithText.isLoadingConfiguredCategoryAPI;
    },
    shouldComponentVisibleAccFrequency() {
      let userProperty = this.modulePropsData?.userSupportType;
      let validOptions = userProperty ? userProperty?.split("$") : [];
      let userData = localStorageFunc.getUserData()?.userData;
      if(userData && typeof(userData) === "string"){
        userData = Utility.decryptData(userData);
      }
      let userFrequency = userData?.frequency;
      let isUserLoggedIn = localStorageFunc.isLoggedIn();
      let optionPresent = [];
      let menuType = "BASIC_GRID"
      if (!isUserLoggedIn) {
        optionPresent.push("NL");
      }

      if (
        userFrequency !== undefined &&
        userFrequency !== null &&
        userFrequency != ""
      ) {
        optionPresent.push(userFrequency);
      }

      const matchFound = validOptions.some(
        (r) => optionPresent.indexOf(r) >= 0
      );

      if(matchFound){
        menuType = 'CONFIGURED_GRID'
      }
      return menuType;
    },
    shouldModuleVisible(){
      if(this.modulePropsData?.showModule?.toLowerCase() === 'true'){
        return true;
      }
      else{
        return false;
      }
    },
    apiConfiguredCategoryData(){
      let data = [];
      if(this.dataApi){
        data = this.$store.state.HorizontalBannerWithText.configuredCategoryData;
        this.HorizontalBannerData = data; 
        if (this.afterExclusionItemCount) {
          this.HorizontalBannerData = this.HorizontalBannerData.slice(
            0,
            this.afterExclusionItemCount,
          );
        }
      }

      const dataLength = this.HorizontalBannerData?.length || 0;
      if(dataLength && this.eventFlag){
        let eventTypeVal = 'carousal';
        if(this.showGridView){
          if(dataLength > 6){
            eventTypeVal = '3*3';
          }
          else{
            eventTypeVal = '2*3';
          }
        }
        this.addUserPropEvent(true , eventTypeVal);
        this.sendEvent(true);   
        this.eventFlag = false;
      }

      return data;
      
    },
    getPlaceHolderImg(){
      const img =  this.$store.getters[keyMapsGetter.GET_PLACE_HOLDER_IMAGE]?.square;
      const fallBack = staticImgBaseUrl + '/images/global/default-product-img-lg.png'
      return img || fallBack;
    },
    getApiLoadeTime(){
      return this.$store.state.HorizontalBannerWithText?.configuredCategoryApiLoadTime;
    },
    getConfiguredCategoryApiFailData(){
      let error =  this.$store.state.HorizontalBannerWithText?.configuredCategoryApiFailData;
      if(this.shouldModuleVisible && error){
        this.addUserPropEvent(false);
        this.sendEvent(false , true , error);
      }
    },
    getMenuGridType(){
      return this.$store.state.HorizontalBannerWithText?.categoryMenuGridType || this.gridTypeV2;
    }
  },
};
</script>

<style lang="scss" scoped></style>
